import { useContext } from 'react';

import errors from '../../../../../constants/errors';
import { ToastNotificationContext } from '../../../toast-notification';

import { HandleDownloadReport } from '../interfaces';

interface Props {
  id: string;
  name: string;
  size?: number;
  downloadFile: HandleDownloadReport;
}
export const useDownloadReport = ({ id, name, size, downloadFile }: Props) => {
  const { openToast } = useContext(ToastNotificationContext);

  const handleDownloadReport = async () => {
    try {
      downloadFile(id, name, size);
    } catch (e) {
      openToast({
        message: errors.somethingWentWrong,
        severity: 'error',
        closeOnClickOnly: true
      });
    }
  };
  return { handleDownloadReport };
};
